import React from 'react'

function Loading() {
    return (
        <div className='loading'>
            
        </div>
    )
}

export default Loading
